export function removeAccountDigit(str: string): string {
  const indiceHifen = str.indexOf('-')
  if (indiceHifen !== -1) {
    return str.substring(0, indiceHifen)
  } else {
    return str
  }
}

export const hasDash = (s: string): string => {
  const regex = /-\w$/
  if (regex.test(s)) {
    return s
  } else {
    const noDash = s.replace('-', '')
    return `${noDash}-0`
  }
}

export const isLetter = (s: string): string => {
  const regex = /[A-Za-z]/
  if (regex.test(s)) {
    return '0'
  } else {
    return s
  }
}

export function truncateString(value: unknown, size: number): string {
  if (typeof value !== 'string' || value === '') return ''
  return value.length > size ? value.slice(0, size) : value
}
